module.exports = __webpack_public_path__ + "img/PJ-BS-fenmian-normol.67db6104.png";